import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';
import { User } from '../user/user.model';

export class PurchaseTrace {
  id?: string;
  dea_id?: string;
  headquarter?: string;
  owner?: User;
  description?: string;
  category?: string;
  custom_category?: string;
  vendor?: string;
  amount?: number;
  currency?: string;
  invoiceReceived?: boolean;
  attachment?: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    this.id = json._id || json.id;
    this.dea_id = json.dea_id;
    this.headquarter = json.headquarter;
    this.owner = new User(json.owner);
    this.description = json.description;
    this.category = json.category;
    this.custom_category = json.custom_category;
    this.vendor = json.vendor;
    this.currency = json.currency;
    this.attachment = json.attachment;
    this.amount = AppJsonDecoder.optPriceValue(json.amount);
    this.invoiceReceived = AppJsonDecoder.optBool(json.invoiceReceived);
    this.createdAt = AppJsonDecoder.optDate(json.createdAt);
    this.updatedAt = AppJsonDecoder.optDate(json.updatedAt);
  }
}
